export default __webpack_public_path__ + "static/media/ruby.231b5b26.png";